import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { AudioPlayerComponent } from '@fc-shared/ui/audio/audio-player.component';
import { convertWaveformToPeaks } from '@fc-shared/ui/audio/audio-waveform.utils';

@Component({
  selector: 'fc-media-view-audio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full w-full items-center justify-center p-16' },
  template: `
    <div class="flex w-full max-w-400 flex-col gap-16">
      <span class="truncate text-center text-base font-medium text-white">
        {{ fileName() }}
      </span>
      <fc-audio-player
        class="justify-center rounded-xl bg-white p-16"
        [source]="source()"
        [label]="fileName()"
        [peaks]="peaks()"
        [durationSeconds]="durationSeconds() ?? null"
      />
    </div>
  `,
  imports: [AudioPlayerComponent],
})
export class MediaViewAudioComponent {
  readonly fileName = input.required<string>();
  readonly source = input.required<string | null>();
  readonly waveform = input<number[] | null | undefined>(null);
  readonly durationSeconds = input<number | null | undefined>(null);

  protected readonly peaks = computed(() =>
    convertWaveformToPeaks(this.waveform()),
  );
}
